import React, { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import moment from 'moment';

import LinkedInimportInstructions from '../../../../../../assets/images/LinkedInimportInstructions.png';
import Modal from '../../../../../../components/shared/Modal/Modal';
import { LINKEDIN_CONNECT } from '../../../../../../constants/commonConstants';
import { IsMobile } from '../../../../../../helpers/IsMobile';
import { sendLinkedInImportEmail } from '../../../../../../redux/actions/linkedInImportActions';

import styles from './InstructionsModal.module.scss';

const InstructionsModal = ({ isOpen, onHide }) => {
  const { t } = useTranslation('common');
  const isMobile = IsMobile();
  const dispatch = useDispatch();

  const handleGoToLinkedIn = useCallback(() => {
    onHide();
    dispatch(sendLinkedInImportEmail(moment.now()));
    window.open(LINKEDIN_CONNECT);
  }, [onHide, dispatch]);

  return (
    <Modal
      show={isOpen}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      fullscreen={isMobile}
    >
      <Modal.CustomHeader closeButton>
        <Modal.Title className={styles.modalTitleMobile} id="contained-modal-title-vcenter">
          {t('linkedinNetwork.addLinkedinConnections')}
        </Modal.Title>
      </Modal.CustomHeader>
      <Modal.Body className={styles.modalBodyMobile}>
        <div className={styles.instructionsContainer}>
          <img src={LinkedInimportInstructions} alt="LinkedInimportInstructions" className={styles.instructionsSvg} />
          <div>
            <p className={styles.instructionsText}>
              <Trans i18nKey="linkedinNetwork.chooseFirstOption" components={{ bold: <b /> }} />
            </p>
          </div>
          <button type="button" className={styles.linkedInBtn} onClick={handleGoToLinkedIn}>
            {t('linkedinNetwork.goToLinkedin')}
          </button>
          <div>
            <p className={styles.instructionsTextLight}>{t('strengthen.downloadReadyNotify')}</p>
            <p className={styles.instructionsTextLight}>{t('strengthen.continueUsingBoon')}</p>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default InstructionsModal;
